import React, {useState, useEffect} from "react";
import gql from "graphql-tag";
import {useMutation} from "react-apollo";

import useAuth from "../../Auth/hooks/useAuth";

export const trackOpenDayMutation = gql`
    mutation TrackOpenDay(
        $name: String!
        $universitySlug: String!
        $product: String!
        $openDayId: String!
    ) {
        trackOpenDay(
            name: $name
            openDayId: $openDayId
            universitySlug: $universitySlug
            product: $product
        ) {
            success
        }
    }
`;

// Open days consumes a number of unibuddy products and these
// constsants can be used thrroughout the Open Days product
export const trackOpenDaysProductSource = {
    OPEN_DAYS: "openDays",
    LIVE_EVENTS: "liveEvents",
    WIDGET: "embeddedUniversityWidget",
};

export function useTrackOpenDay(name, universitySlug, product, openDayId) {
    const [trackOpenDay] = useMutation(trackOpenDayMutation);
    const {isLoggedIn, user} = useAuth();
    const accountRole = user ? user.accountRole : null;
    const [success, setSuccess] = useState(null);
    useEffect(
        () => {
            async function fetchData() {
                const result = await trackOpenDay({
                    variables: {
                        name,
                        universitySlug,
                        product,
                        openDayId,
                    },
                });

                if (result && result.data) {
                    setSuccess(result.data.trackOpenDay.success);
                }
            }
            if (
                isLoggedIn &&
                name &&
                universitySlug &&
                product &&
                openDayId &&
                accountRole === "applicant"
            ) {
                fetchData();
            }

            // Clean up for the tests, we need to make sure
            // that state is set to null when the component
            // remounts.
            return () => setSuccess(null);
        },
        [
            isLoggedIn,
            name,
            universitySlug,
            product,
            openDayId,
            trackOpenDay,
            accountRole,
            setSuccess,
        ],
    );

    return success;
}

/**
 * Provides a way for legacy React components to access the TrackOpenDay
 * mutation as a prop. This has been intended to be implemented in the
 * Registration, login and landing page (Live Events) flow.
 *
 * @export
 * @param {*} Component
 * @returns
 */

function withTrackOpenDay(Component) {
    return function WrappedComponent(props) {
        const [trackOpenDay] = useMutation(trackOpenDayMutation);
        return <Component {...props} trackOpenDay={trackOpenDay} />;
    };
}

export default withTrackOpenDay;
